/// <amd-module name="VSSUI/VssContextualMenu" />
export * from "./Components/VssContextualMenu/index";
